<template>
    <div class="stage-category-create-input">
        <div class="stage-category-create-input-wrap">
            <input
                :value="color"
                class="stage-category-create-color-input"
                type="color"
                @input="$emit('update:color', $event.target.value)"
            >
            <span class="stage-category-create-color-dot" :style="{ backgroundColor: color || 'var(--ui-text-subtle)' }"></span>
            <input
                ref="nameInput"
                :value="name"
                :maxlength="maxlength"
                :placeholder="placeholder"
                class="form-input text-sm stage-category-create-title-input"
                type="text"
                @input="$emit('update:name', $event.target.value)"
                @keyup.enter="$emit('submit')"
            >
        </div>
        <button class="stage-category-create-add-btn" type="button" @click="$emit('submit')">
            <svg-vue class="h-4 w-4" aria-hidden="true" icon="font-awesome.regular.plus"></svg-vue>
        </button>
    </div>
</template>

<script>
import {UI_COLORS} from '@/utils/ui-colors';

export default {
    name: "category-create-input",
    props: {
        color: {
            type: String,
            default: UI_COLORS.text.subtle,
        },
        maxlength: {
            type: [Number, String],
            default: 120,
        },
        name: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    emits: ['submit', 'update:color', 'update:name'],
    methods: {
        focusInput() {
            const input = this.$refs.nameInput;
            if (input && typeof input.focus === 'function') {
                input.focus();
            }
        },
    },
}
</script>

<style scoped>
.stage-category-create-input {
    display: flex;
    align-items: stretch;
    width: 100%;
    min-height: 2.375rem;
}

.stage-category-create-input-wrap {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
}

.stage-category-create-color-input {
    position: absolute;
    left: 0;
    top: 0;
    width: 2.75rem;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.stage-category-create-color-dot {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    width: 1rem;
    height: 1rem;
    margin-top: -0.5rem;
    border-radius: 9999px;
    pointer-events: none;
}

.stage-category-create-title-input {
    width: 100%;
    min-height: 2.375rem;
    border: 0;
    border-right: 1px solid var(--ui-border-subtle);
    border-radius: 0 !important;
    padding-left: 2.2rem !important;
    padding-right: 0.75rem !important;
}

.stage-category-create-title-input:focus {
    border-color: var(--ui-border-subtle) !important;
    box-shadow: none !important;
}

.stage-category-create-add-btn {
    width: 2.75rem;
    min-width: 2.75rem;
    border: 0;
    background: #fff;
    color: var(--ui-text-default);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none;
    appearance: none;
    box-shadow: none !important;
}

.stage-category-create-add-btn:hover {
    color: var(--ui-text-strong);
    background: #fff;
    box-shadow: none !important;
}

.stage-category-create-add-btn:focus,
.stage-category-create-add-btn:focus-visible,
.stage-category-create-add-btn:active {
    outline: none !important;
    box-shadow: none !important;
}
</style>
